/* SilkPearl product page — variant switching, quantity, gallery */
(function () {
  'use strict';

  var root = document.querySelector('[data-sp-product]');
  if (!root) return;

  var dataEl = root.querySelector('[data-sp-variants]');
  var variants = [];
  try {
    variants = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }

  var idInput = root.querySelector('[data-sp-variant-id]');
  var addBtn = root.querySelector('[data-sp-add]');
  var addLabel = root.querySelector('[data-sp-add-label]');
  var priceNow = root.querySelector('[data-sp-price-now]');
  var priceWas = root.querySelector('[data-sp-price-was]');
  var priceSave = root.querySelector('[data-sp-price-save]');

  /* ---------- money ---------- */
  var moneyFormat = (window.Shopify && window.Shopify.money_format) || '${{amount}}';
  /* Pakistan market fix, 21 Sep 2026. shop.currencyFormats.moneyFormat is
     ONE global template shop-wide, confirmed via the Admin API — there is
     no per-currency override to fall back on. Every price this function
     rewrites after page load (variant switch, bundle tiers, the sticky
     add-to-bag label, gift-unlock messaging) was showing "$" on a PKR page
     because of that, even though the initial server render used the
     money_without_trailing_zeros filter and got it right. window.Shopify.
     currency.active is already correct client-side (confirmed live), so
     mirror the same symbol swap the Liquid-side fix uses. */
  if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active === 'PKR') {
    moneyFormat = moneyFormat.replace('$', 'Rs.');
  }
  function money(cents) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var out = whole + '.' + parts[1];
    // handle the common Shopify placeholders
    return moneyFormat
      .replace(/\{\{\s*amount\s*\}\}/, out)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, whole)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, out.replace(/,/g, '.').replace(/\.(\d{2})$/, ',$1'))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, whole.replace(/,/g, '.'));
  }

  /* ---------- selection ---------- */
  function selectedOptions() {
    var out = [];
    root.querySelectorAll('[data-sp-option-index]').forEach(function (group) {
      var checked = group.querySelector('[data-sp-option-input]:checked');
      out.push(checked ? checked.value : null);
    });
    return out;
  }

  function findVariant(opts) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var match = true;
      for (var j = 0; j < opts.length; j++) {
        if (opts[j] !== null && v.options[j] !== opts[j]) {
          match = false;
          break;
        }
      }
      if (match) return v;
    }
    return null;
  }

  function updateGalleryFor(variant) {
    if (!variant || !variant.featured_media) return;
    show(String(variant.featured_media.id));
  }

  function render(variant) {
    if (!variant) {
      if (addBtn) addBtn.disabled = true;
      if (addLabel) addLabel.textContent = 'Unavailable';
      return;
    }

    if (idInput) idInput.value = variant.id;

    if (addBtn) addBtn.disabled = !variant.available;
    if (addLabel) {
      addLabel.textContent = variant.available
        ? 'Add to bag \u2014 ' + money(variant.price)
        : 'Sold out';
    }

    // sticky bar mirrors the current variant
    var sVariant = document.querySelector('[data-sp-sticky-variant]');
    var sLabel = document.querySelector('[data-sp-sticky-label]');
    var sAdd = document.querySelector('[data-sp-sticky-add]');
    if (sVariant) sVariant.textContent = variant.title;
    if (sLabel) {
      sLabel.textContent = variant.available
        ? 'Add to bag \u2014 ' + money(variant.price)
        : 'Sold out';
    }
    if (sAdd) {
      sAdd.disabled = !variant.available;
      sAdd.setAttribute('data-sp-quick-add', variant.id);
    }

    // instalment note
    /* Shop Pay Installments renders itself from the hidden id in its own
       form, so point that at the new variant and let Shopify recompute the
       instalment figure. We no longer write the amount ourselves — doing so
       meant our sentence and the real terms could disagree. */
    var payId = document.querySelector('[data-sp-installment-id]');
    if (payId) {
      payId.value = variant.id;
      payId.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // low-stock line is variant specific and server rendered; hide on switch
    var stock = document.querySelector('[data-sp-stock]');
    if (stock) stock.hidden = true;

    if (priceNow) priceNow.textContent = money(variant.price);

    var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
    if (priceWas) {
      priceWas.hidden = !onSale;
      if (onSale) priceWas.textContent = money(variant.compare_at_price);
    }
    if (priceSave) {
      priceSave.hidden = !onSale;
      if (onSale) {
        // percentage, matching the server-rendered badge
        var pct = Math.round(
          ((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100
        );
        priceSave.textContent = 'Save ' + pct + '%';
      }
    }

    // reflect the chosen value next to each option legend
    root.querySelectorAll('[data-sp-option-index]').forEach(function (group) {
      var idx = group.getAttribute('data-sp-option-index');
      var label = root.querySelector('[data-sp-option-label="' + idx + '"]');
      var checked = group.querySelector('[data-sp-option-input]:checked');
      if (label && checked) label.textContent = checked.value;
    });

    updateGalleryFor(variant);

    // keep the URL shareable without reloading
    if (window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }
  }

  root.addEventListener('change', function (e) {
    if (!e.target.matches('[data-sp-option-input]')) return;
    previewing = false;
    render(findVariant(selectedOptions()));
  });

  /* ---------- quantity ---------- */
  var qtyInput = root.querySelector('[data-sp-qty-input]');
  function bump(delta) {
    if (!qtyInput) return;
    var next = parseInt(qtyInput.value, 10) + delta;
    if (isNaN(next) || next < 1) next = 1;
    qtyInput.value = next;
  }
  var down = root.querySelector('[data-sp-qty-down]');
  var up = root.querySelector('[data-sp-qty-up]');
  if (down) down.addEventListener('click', function () { bump(-1); });
  if (up) up.addEventListener('click', function () { bump(1); });
  if (qtyInput) {
    qtyInput.addEventListener('change', function () {
      var n = parseInt(qtyInput.value, 10);
      qtyInput.value = isNaN(n) || n < 1 ? 1 : n;
    });
  }

  /* ---------- gallery ---------- */
  function show(mediaId) {
    var slide = root.querySelector('[data-sp-slide="' + mediaId + '"]');
    if (!slide) return;
    root.querySelectorAll('[data-sp-slide]').forEach(function (s) {
      var active = s === slide;
      s.hidden = !active;
      s.classList.toggle('is-active', active);
    });
    root.querySelectorAll('[data-sp-thumb]').forEach(function (t) {
      var active = t.getAttribute('data-sp-thumb') === String(mediaId);
      t.classList.toggle('is-active', active);
      t.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  root.querySelectorAll('[data-sp-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      show(thumb.getAttribute('data-sp-thumb'));
    });
  });

  /* ---------- bundle & save ----------
     The tier prices shown must match what Shopify charges. The percentages
     come from section settings that mirror the automatic discounts; gifts are
     $0 products added as extra lines, because Buy-X-Get-Y cannot stack with
     the tier percentage. */
  var bundle = root.querySelector('[data-sp-bundle]');
  if (bundle) {
    var giftMin = Number(bundle.getAttribute('data-gift-min')) || 0;
    var giftBag = bundle.getAttribute('data-gift-bag');
    var giftPouch = bundle.getAttribute('data-gift-pouch');
    var tierPct = {
      2: Number(bundle.getAttribute('data-tier2')) || 0,
      3: Number(bundle.getAttribute('data-tier3')) || 0
    };

    var extras = root.querySelector('[data-sp-extras]');

    /* Show a colour picker for mask 2 and 3 as the tier grows. Without this
       the shopper gets N of whatever colour is selected at the top. */
    var paintExtras = function (chosen) {
      if (!extras) return;
      extras.hidden = chosen < 2;
      [].forEach.call(extras.querySelectorAll('[data-sp-extra]'), function (slot) {
        slot.hidden = Number(slot.getAttribute('data-sp-extra')) > chosen;
      });
    };

    var extraVariantFor = function (slot, fallbackId) {
      if (!extras) return fallbackId;
      var el = extras.querySelector('[data-sp-extra="' + slot + '"]');
      if (!el || el.hidden) return fallbackId;
      var on = el.querySelector('[data-sp-extra-input]:checked');
      return on ? Number(on.value) : fallbackId;
    };

    if (extras) {
      extras.addEventListener('change', function (e) {
        var input = e.target.closest('[data-sp-extra-input]');
        if (!input) return;
        var slot = input.closest('[data-sp-extra]');
        [].forEach.call(slot.querySelectorAll('.sp-bndl__sw'), function (l) {
          l.classList.toggle('is-active', l.contains(input));
        });
        var name = slot.querySelector('[data-sp-extra-name]');
        if (name) name.textContent = input.getAttribute('data-title') || '';
      });
    }

    var sub = root.querySelector('[data-sp-subscribe]');
    var subCode = sub ? sub.getAttribute('data-code') : '';
    var subPct = sub ? Number(sub.getAttribute('data-pct')) || 0 : 0;
    var subToggle = sub ? sub.querySelector('[data-sp-sub-toggle]') : null;
    var subField = sub ? sub.querySelector('[data-sp-sub-field]') : null;
    var subEmail = sub ? sub.querySelector('[data-sp-sub-email]') : null;
    var subMsg = sub ? sub.querySelector('[data-sp-sub-msg]') : null;
    var subNow = sub ? sub.querySelector('[data-sp-sub-now]') : null;
    var subWas = sub ? sub.querySelector('[data-sp-sub-was]') : null;
    var subOn = function () { return Boolean(subToggle && subToggle.checked); };

    var say = function (text, bad) {
      if (!subMsg) return;
      subMsg.hidden = !text;
      subMsg.textContent = text || '';
      subMsg.classList.toggle('is-bad', Boolean(bad));
    };

    if (sub) {
      sub.addEventListener('change', function (e) {
        if (!e.target.matches('[data-sp-sub-toggle]')) return;
        sub.classList.toggle('is-on', subOn());
        if (subField) subField.hidden = !subOn();
        say('');
        paintBundle();
        if (subOn() && subEmail) subEmail.focus();
      });
    }

    var tierQty = function () {
      var on = bundle.querySelector('[data-sp-tier-input]:checked');
      return on ? Number(on.value) : 1;
    };

    var bundleTotal = function (qty, variant) {
      var unit = variant ? variant.price : Number(bundle.getAttribute('data-unit'));
      var gross = unit * qty;
      var pct = tierPct[qty] || 0;
      return { gross: gross, net: gross - Math.round((gross * pct) / 100) };
    };

    /* Celebrate a gift the moment it becomes available, not on every repaint.
       Seeded on the first run so nothing fires on page load. */
    var lastCelebrated = null;
    var celebrate = function (el) {
      if (!el || el.hidden) return;
      if (window.matchMedia('(prefers-reduced-motion:reduce)').matches) return;
      el.classList.remove('is-unlocked');
      void el.offsetWidth; /* restart the animation; rAF is paused in background tabs */
      el.classList.add('is-unlocked');
      window.setTimeout(function () { el.classList.remove('is-unlocked'); }, 1400);
    };

    var paintBundle = function () {
      var variant = findVariant(selectedOptions());
      var chosen = tierQty();

      [].forEach.call(bundle.querySelectorAll('.sp-bndl__opt'), function (opt) {
        var q = Number(opt.getAttribute('data-sp-tier'));
        var sums = bundleTotal(q, variant);
        opt.classList.toggle('is-active', q === chosen);

        var now = opt.querySelector('.sp-bndl__now');
        var was = opt.querySelector('.sp-bndl__was');
        var save = opt.querySelector('.sp-bndl__save');
        if (now) now.textContent = money(sums.net);
        if (was) was.textContent = money(sums.gross);
        if (save) save.textContent = 'Save ' + money(sums.gross - sums.net);

        /* gifts are gated on cart value, so a cheap mask may not reach it */
        var gifts = opt.querySelector('[data-sp-gifts]');
        var locked = opt.querySelector('[data-sp-locked]');
        var qualifies = sums.net >= giftMin;
        if (gifts) gifts.hidden = !qualifies;
        if (locked) {
          locked.hidden = qualifies;
          /* Two masks earn one gift, three earn two. Say which. */
          if (!qualifies) {
            var noun = Number(opt.getAttribute('data-sp-tier')) >= 3 ? 'free gifts' : 'the free gift';
            locked.textContent = 'Add ' + money(giftMin - sums.net) + ' more to unlock ' + noun;
          }
        }
      });

      /* the list signup takes a further cut off whatever tier is chosen */
      var tierNet = bundleTotal(chosen, variant).net;
      var finalNet = tierNet;
      if (sub) {
        var subNet = tierNet - Math.round((tierNet * subPct) / 100);
        if (subNow) subNow.textContent = money(subNet);
        if (subWas) subWas.textContent = money(tierNet);
        if (subOn()) finalNet = subNet;
      }

      paintExtras(chosen);

      /* Flash the gift row when the shopper moves onto a tier that earns one.
         `lastCelebrated === null` is the first paint, so it only records. */
      var chosenOpt = bundle.querySelector('.sp-bndl__opt[data-sp-tier="' + chosen + '"]');
      var chosenGifts = chosenOpt ? chosenOpt.querySelector('[data-sp-gifts]') : null;
      var earns = chosenGifts && !chosenGifts.hidden;
      if (lastCelebrated !== null && earns && lastCelebrated !== chosen) celebrate(chosenGifts);
      lastCelebrated = chosen;

      if (qtyInput) qtyInput.value = chosen;
      if (addLabel && variant && variant.available) {
        addLabel.textContent = 'Add to bag \u2014 ' + money(finalNet);
      }
    };

    bundle.addEventListener('change', function (e) {
      if (e.target.matches('[data-sp-tier-input]')) paintBundle();
    });
    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-sp-option-input]')) paintBundle();
    });

    var form = root.querySelector('#sp-product-form');
    if (form) {
      form.addEventListener('submit', function (e) {
        var variant = findVariant(selectedOptions());
        if (!variant || !variant.available) return;
        e.preventDefault();

        var qty = tierQty();

        /* one line per mask so each can be a different colour; Shopify merges
           lines that happen to match, and the tier counts total quantity */
        var picked = [variant.id];
        for (var slot = 2; slot <= qty; slot++) picked.push(extraVariantFor(slot, variant.id));

        var tally = {};
        picked.forEach(function (id) { tally[id] = (tally[id] || 0) + 1; });
        var items = Object.keys(tally).map(function (id) {
          return { id: Number(id), quantity: tally[id] };
        });
        if (bundleTotal(qty, variant).net >= giftMin) {
          if (qty >= 2 && giftBag) items.push({ id: Number(giftBag), quantity: 1 });
          if (qty >= 3 && giftPouch) items.push({ id: Number(giftPouch), quantity: 1 });
        }

        var previous = addLabel ? addLabel.textContent : '';
        if (addBtn) addBtn.disabled = true;
        if (addLabel) addLabel.textContent = 'Adding\u2026';

        /* Sign the shopper up first: if the address is bad we want to fail
           before anything lands in the cart. */
        var signup = Promise.resolve();
        if (subOn()) {
          var address = subEmail ? subEmail.value.trim() : '';
          if (!address || address.indexOf('@') < 1) {
            say('Enter an email address to claim the extra ' + subPct + '%.', true);
            if (subEmail) subEmail.focus();
            if (addBtn) addBtn.disabled = false;
            if (addLabel) addLabel.textContent = previous;
            return;
          }
          var body = new URLSearchParams();
          body.set('form_type', 'customer');
          body.set('utf8', '\u2713');
          body.set('contact[email]', address);
          body.set('contact[tags]', 'newsletter,bundle-signup');
          signup = fetch('/contact', { method: 'POST', body: body })
            .then(function () { return fetch('/discount/' + encodeURIComponent(subCode)); })
            .then(function () { say('You are on the list — ' + subPct + '% applied.'); })
            .catch(function () { say('Signed up, but the discount did not attach. It can be entered at checkout.', true); });
        }

        signup.then(function () {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: items })
          });
        })
          .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
          .then(function () {
            if (addBtn) addBtn.disabled = false;
            if (addLabel) addLabel.textContent = previous;
            /* Fly the mask into the bag. Decoration only — it runs after the
               add has already succeeded, so it can never delay or block one. */
            if (window.SilkPearl && window.SilkPearl.flyToBag) {
              var shot = document.querySelector('.sp-pdp__slide.is-active .sp-pdp__img, .sp-pdp__img');
              /* addBtn is the fallback origin: by the time anyone reaches the
                 bundle the gallery is usually scrolled off the top. */
              window.SilkPearl.flyToBag(shot, addBtn);
            }
            document.dispatchEvent(new CustomEvent('sp:cart:changed'));
          })
          .catch(function () {
            if (addLabel) addLabel.textContent = 'Could not add';
            window.setTimeout(function () {
              if (addLabel) addLabel.textContent = previous;
              if (addBtn) addBtn.disabled = false;
            }, 2400);
          });
      });
    }

    paintBundle();
  }

  /* ---------- swatch hover preview ---------- */
  /* Previews a colour in the gallery without committing it. Leaving the row
     restores whatever variant is actually selected. Mouse only: touch fires a
     compatibility pointerover just before click, with no pointerout to undo it. */
  var previewing = false;

  function hoverCapable() {
    return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  }

  function mediaIdFor(opts) {
    var v = findVariant(opts);
    return v && v.featured_media ? String(v.featured_media.id) : null;
  }

  function previewMediaId(groupIndex, value) {
    /* keep the shopper's other choices (e.g. pillowcase size) */
    var opts = selectedOptions();
    opts[groupIndex] = value;
    var id = mediaIdFor(opts);
    if (id) return id;
    /* that combination may not exist — fall back to the colour alone */
    var loose = [];
    for (var i = 0; i < opts.length; i++) loose.push(i === groupIndex ? value : null);
    return mediaIdFor(loose);
  }

  root.addEventListener('pointerover', function (e) {
    if (e.pointerType && e.pointerType !== 'mouse') return;
    if (!hoverCapable()) return;
    var label = e.target.closest && e.target.closest('.sp-pdp__swatch');
    if (!label) return;
    var group = label.closest('[data-sp-option-index]');
    var input = document.getElementById(label.getAttribute('for'));
    if (!group || !input) return;
    var id = previewMediaId(parseInt(group.getAttribute('data-sp-option-index'), 10), input.value);
    if (!id) return;
    previewing = true;
    show(id);
  });

  root.addEventListener('pointerout', function (e) {
    if (e.pointerType && e.pointerType !== 'mouse') return;
    if (!previewing) return;
    var list = e.target.closest && e.target.closest('.sp-pdp__opt-list--swatch');
    if (!list) return;
    /* moving between swatches in the same row is not a leave */
    if (e.relatedTarget && list.contains(e.relatedTarget)) return;
    previewing = false;
    var id = mediaIdFor(selectedOptions());
    if (id) show(id);
  });

  /* ---------- add-to-bundle upsell ----------
     Its own add path: several optional lines, no tier logic, no gifts. */
  var ups = root.querySelector('[data-sp-upsell]');
  if (ups) {
    var upsAdd = ups.querySelector('[data-sp-ups-add]');
    var upsLabel = ups.querySelector('[data-sp-ups-label]');

    var upsChosen = function () {
      return [].slice.call(ups.querySelectorAll('[data-sp-ups-item]:checked'));
    };

    var paintUps = function () {
      var picked = upsChosen();
      var total = picked.reduce(function (sum, el) {
        return sum + (Number(el.getAttribute('data-price')) || 0);
      }, 0);
      [].forEach.call(ups.querySelectorAll('.sp-ups__row'), function (row) {
        var box = row.querySelector('[data-sp-ups-item]');
        row.classList.toggle('is-on', Boolean(box && box.checked));
      });
      if (upsAdd) upsAdd.disabled = picked.length === 0;
      if (upsLabel) {
        upsLabel.textContent = picked.length === 0
          ? 'Select to add'
          : 'Add ' + picked.length + (picked.length === 1 ? ' item \u2014 ' : ' items \u2014 ') + money(total);
      }
    };

    ups.addEventListener('change', function (e) {
      if (e.target.matches('[data-sp-ups-item]')) paintUps();
    });

    if (upsAdd) {
      upsAdd.addEventListener('click', function () {
        var picked = upsChosen();
        if (!picked.length) return;
        var previous = upsLabel ? upsLabel.textContent : '';
        upsAdd.disabled = true;
        if (upsLabel) upsLabel.textContent = 'Adding\u2026';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: picked.map(function (el) { return { id: Number(el.value), quantity: 1 }; })
          })
        })
          .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
          .then(function () {
            picked.forEach(function (el) { el.checked = false; });
            paintUps();
            document.dispatchEvent(new CustomEvent('sp:cart:changed'));
          })
          .catch(function () {
            if (upsLabel) upsLabel.textContent = 'Could not add';
            window.setTimeout(function () {
              if (upsLabel) upsLabel.textContent = previous;
              upsAdd.disabled = false;
            }, 2400);
          });
      });
    }

    paintUps();
  }

  /* ---------- sticky bar ---------- */
  var sticky = document.querySelector('[data-sp-sticky]');
  var addBlock = root.querySelector('.sp-pdp__actions');
  if (sticky && addBlock) {
    sticky.hidden = false;
    var onScroll = function () {
      var r = addBlock.getBoundingClientRect();
      // show once the real button has scrolled out of view
      sticky.classList.toggle('is-on', r.bottom < 0);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- initial state ---------- */
  render(findVariant(selectedOptions()));
})();
